"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const UIDRenderer = {
    renderV1(uid) {
        return { value: uid.value };
    },
    renderV2(_def, uid) {
        return uid.value;
    },
    renderDefault(_) {
        return null;
    },
    renderMocks(_def, uid) {
        return uid.value;
    },
};
exports.default = UIDRenderer;
